export default "__VITE_ASSET__cfc4c3d8__"